import React, { useState } from "react";
import "../Styles/FAQ.css"; 
import bgImage from "../Assets/faq_background.png";
import img7 from "../Assets/bg4.jpg"; 
import Parallax from "./Parallax";

const faqs = [
  {
    question: "Why should I do my web design and development from DD Digital Construction?",
    answer:
      "Choose DD Digital Construction for web design and development and transform your online presence into a powerful business tool. We create custom, responsive, and visually stunning websites that not only captivate your audience but are optimized for speed, SEO, and conversions. Using the latest technologies and a results-driven approach, we deliver websites that grow with your business. From design to digital marketing support, we provide end-to-end solutions with transparency, reliability, and creativity — making us the digital partner you can trust.",
  },
  {
    question: "Why is India an ideal choice for web development outsourcing?",
    answer:
      "India offers highly skilled developers, cost-effectiveness, and timely delivery which makes it a preferred outsourcing hub.",
  },
  {
    question: "How to find the best web design company in India?",
    answer:
      "Look for experience, portfolio, client testimonials, and global recognition before finalizing a company.",
  },
  {
    question: "How much does it cost to hire a web developer in India?",
    answer:
      "The cost varies depending on project size, technology, and expertise required. Generally, it’s much more affordable compared to western countries.",
  },
  {
    question: "Do you custom website design or use pre-built templates?",
    answer:
      "We provide both options depending on client requirements. However, custom solutions ensure uniqueness.",
  },
  {
    question: "In which technology should I do my web development?",
    answer:
      "It depends on your project goals. Popular choices are React, Angular, Node.js, PHP, and WordPress.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
     <Parallax
        background={img7}
        heading="Experience the Difference"
        description="We combine creativity and technology to build modern digital experiences that inspire and engage."
      />
      {/* FAQ Section */}
      <section
        className="faq-section"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="faq-container">
          <h2 className="faq-heading">FAQs</h2>
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${activeIndex === index ? "active" : ""}`}
            >
              <div className="faq-question" onClick={() => toggleFAQ(index)}>
                <h3>{item.question}</h3>
                <span className="faq-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </div>
              {activeIndex === index && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* Parallax Section */}
     
    </>
  );
};

export default FAQ;
